<template lang="pug">
.activity
    submenu
        activity-submenu
    .content
        page-header
            h1.highlight Activity
            template(slot="actions")
                el-input(placeholder="Search schools", prefix-icon="el-icon-search", v-model="search.school_name")
        template(v-if="!$apollo.loading")
            div(v-if="activityFiltered && activityFiltered.length")
                el-table(:data="activityFiltered" @sort-change="handleSort")
                    el-table-column( label='School name' property="school_name", width='500' :show-overflow-tooltip="true")
                        template(slot-scope="scope")
                            router-link(:to="{ name: 'schools.show', params: { school: scope.row.school_id } }")
                                strong {{ scope.row.school_name }}
                    el-table-column(property="company_name", label="Company")
                    el-table-column(property="type", label="Type" sortable )
                        template(slot-scope="scope")
                            el-tag(size="small", :type="activityType(scope.row.type)") {{ scope.row.type | capitalise }}
                    el-table-column(property="date", label="Date" sortable)
                        template(slot-scope="scope") {{ scope.row.date | standard_datetime }}
                pagination
                    el-pagination(layout='prev, pager, next', background, :page-size="pageSize", :current-page="currentPage" :total='activityItemsCount', @current-change="handleCurrentChange")
            page(v-else)
                empty No activities found
                    span(v-if="search.school_name") &nbsp;for search term "{{ search.school_name }}"
</template>

<script>
import ActivitySubmenu from "./includes/ActivitySubmenu";
import gql from "graphql-tag";
import { orderBy, chunk } from "lodash";

export default {
	components: {
		ActivitySubmenu
	},
	data: () => ({
		pageSize: 30,
		search: {
			school_name: null,
			school_id: null
		}
	}),
	computed: {
		currentPage: {
			get() {
				return parseInt(this.$route.query.page || 1);
			},
			set(value) {
				this.$router.push({ query: { ...this.$route.query, page: value } });
			}
		},
		activityFiltered() {
			let activities = this.ActivityItems || [];

			if (!activities.length) return [];

			if (this.search.school_name) {
				activities = activities.filter(a => a.school_name.toLowerCase().includes(this.search.school_name.toLowerCase()));
			}

			let chunkedItems = chunk(activities, this.pageSize);
			if (chunkedItems.length < this.currentPage) {
				// eslint-disable-next-line
				this.currentPage = chunkedItems.length;
			}
			return chunkedItems[this.currentPage - 1];
		},
		activityItemsCount() {
			return this.ActivityItems ? this.ActivityItems.length : 0;
		}
	},
	methods: {
		handleCurrentChange(page) {
			this.$router.push({ query: { ...this.$route.query, page: page } });
		},
		// eslint-disable-next-line
		handleSort({ column, prop, order }) {
			order = order == "ascending" ? "asc" : "desc";
			this.ActivityItems = orderBy(this.ActivityItems, prop, order);
			this.currentPage = 1;
		},
		activityType(type) {
			let tag = "";
			switch (type) {
				case "requested":
					tag = "primary";
					break;
				case "approved":
					tag = "success";
					break;
				case "declined":
					tag = "warning";
					break;
				case "revoked":
					tag = "danger";
					break;
				default:
					tag = "info";
					break;
			}
			return tag;
		}
	},
	apollo: {
		ActivityItems: {
			query: gql`
				query ActivityItems($type: String) {
					ActivityItems(type: $type) {
						id
						type
						company_id
						school_id
						date
						school_name
						company_name
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			variables() {
				return {
					type: this.$route.query.type
				};
			}
		}
	}
};
</script>
